document.addEventListener('DOMContentLoaded', function () {
  if (!window.jQuery) return;

  function initZoom() {
    var $img = jQuery('#zoom_main');

    if (!$img.length) return;

    // destroy previous instance if any
    var plugin = $img.data('ezPlus');
    if (plugin && typeof plugin.destroy === 'function') {
      plugin.destroy();
      jQuery('.zoomContainer').remove();
    }

    $img.ezPlus({
      zoomType: 'window',    // 'window', 'lens', or 'inner'
      scrollZoom: true,
      responsive: true,
      cursor: 'crosshair'
      // you can add more options later
    });
  }

  initZoom();

  // Example hooks – we'll adjust once I see your code:
  // 1) When a thumbnail is clicked
  jQuery(document).on('click', '.product__thumbnail, .media-thumbnail', function () {
    // Your theme will change the main image; after that, re-init:
    setTimeout(initZoom, 50);
  });

  // 2) When a variant changes (Online Store 2.0 event pattern)
  document.addEventListener('variant:changed', function () {
    setTimeout(initZoom, 50);
  });
});
